export default __webpack_public_path__ + "static/media/investors_logo12.743cb379.png";